import React from 'react'

const LockIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="lockGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(200, 160, 120, 1)" />
          <stop offset="100%" stopColor="rgba(160, 120, 80, 1)" />
        </linearGradient>
        <filter id="lockGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Lock body */}
      <rect 
        x="6" 
        y="11" 
        width="12" 
        height="10" 
        rx="2"
        fill="url(#lockGradient)"
        filter="url(#lockGlow)"
      />
      
      {/* Lock shackle */}
      <path 
        d="M8 11V7a4 4 0 0 1 8 0v4"
        stroke="url(#lockGradient)"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        filter="url(#lockGlow)"
      />
      
      {/* Keyhole */}
      <circle 
        cx="12" 
        cy="16" 
        r="1.5" 
        fill="rgba(255, 255, 255, 0.7)"
      />
    </svg>
  )
}

export default LockIcon
